<template>
  <div
    id="affixContainer"
    data-offset-top="40"
    ref="affix"
    :class="[ 'affix', icsType ,{ phone: $md.phone(), tablet: $md.tablet() }]"
  >
    <ld-json items="ldJsonItems"></ld-json>

    <div class="heatmap">
      <ul id="highlightLinks">
        <li><a :class="{active: currentPage === 'home'}" :href="siteUrl">{{ this.$t('main.DRAWER_INDEX') }}</a></li>
        <li><a :class="{active: currentPage === 'building'}" :href="siteUrl + 'building'">{{ this.$t('main.BLDG_PAGE_SH') }}</a></li>
        <li><a :class="{active: activeStockTab}" :href="siteUrl + 'openday'"> {{ this.$t('main.OPEN_DAY') }}</a></li>
        <li><a :class="{active: currentPage === 'video'}" :href="siteUrl + 'video'"> {{ this.$t('main.DRAWER_VIDEOS') }}</a></li>
        <li @mouseover="showAgentTabs = true"
            @mouseleave="showAgentTabs = false">
          <a :class="{active: activeAgentTab}" :href="siteUrl + 'agent'">{{ this.$t('main.DRAWER_AGENT') }}</a>
          <a v-show="showAgentTabs" :href="siteUrl + 'mitaclub'">{{ this.$t('main.MITA_CLUB') }}</a>
          <a v-show="showAgentTabs" :href="siteUrl + 'recommend/office'">{{ this.$t('main.DRAWER_MONTHLY_RECOMMENDATION_S') }}</a>
          <a v-show="showAgentTabs" :href="siteUrl + 'topsales/office'">{{ this.$t('main.DRAWER_TOP_10_SALES_S') }}</a>
          <a v-show="showAgentTabs" :href="siteUrl + 'recommend'">{{ this.$t('main.HEADS_RECOMMEND') }}</a>
        </li>
        <li @mouseover="showNewsTabs = true"
            @mouseleave="showNewsTabs = false">
          <a :class="{active: activeNewstab}" href="#">{{ this.$t('main.DRAWER_NEWS_INFO') }}</a>
          <a v-show="showNewsTabs" :href="siteUrl + 'dailynews'">{{ this.$t('main.DRAWER_NEWS_COMMON') }}</a>
          <a v-show="showNewsTabs" :href="siteUrl + 'columns'">{{ this.$t('main.DRAWER_DANIEL_BLOG') }}</a>
          <a v-show="showNewsTabs" :href="siteUrl + 'news'">{{ this.$t('main.DRAWER_NEWS') }}</a>
          <a v-show="showNewsTabs" :href="siteUrl + 'research'">{{ this.$t('main.DRAWER_RESEARCH_DEPT') }}</a>
          <a v-show="showNewsTabs" :href="siteUrl + 'shops_map'">{{ this.$t('main.DRAWER_SHOPS_MAP') }}</a>
          <a v-show="showNewsTabs" :href="siteUrl + 'walk_street_guide'">{{ this.$t('main.DRAWER_WALK_STREET_GUIDE') }}</a>
        </li>        
        <li @mouseover="showBranchTabs = true"
            @mouseleave="showBranchTabs = false">
          <a :class="{active: activeBranchTab}" href="#">{{ this.$t('main.DRAWER_BRANCH_OR_INQUIRE') }}</a>
          <a v-show="showBranchTabs" :href="siteUrl + 'branch'">{{ this.$t('main.BRANCH') }}</a>
          <a v-show="showBranchTabs" :href="siteUrl + 'contactus'">{{ this.$t('main.CONTACT_US') }}</a>
          <a v-show="showBranchTabs" :href="siteUrl + 'contactus/easy_i'">{{ this.$t('main.REQUEST_FORM') }}</a>
          <a v-show="showBranchTabs" :href="siteUrl + 'tender'">{{ this.$t('main.DRAWER_TENDER') }}</a>
          <a v-show="showBranchTabs" :href="corpUrl">{{ this.$t('main.CORP') }}</a>
          <a v-show="showBranchTabs" :href="siteUrl + 'recruitment'">{{ this.$t('main.RECURITMENT') }}</a>
          <a v-show="showBranchTabs" :href="siteUrl + 'partner'">{{ this.$t('main.PARTNERSHIP') }}</a>
          <a v-show="showBranchTabs" :href="siteUrl + 'member'">{{ this.$t('main.MEMBERSHIP') }}</a>
          <a v-show="showBranchTabs" :href="siteUrl + 'payment_method'">{{ this.$t('main.PAYMENT_METHOD') }}</a>
        </li>
      </ul>
    </div>
    
    <div class="container-fluid">
      <slot></slot>
    </div>
  </div>
</template>
<script>
  import Stickyfill from 'stickyfill';
  import LdJson from '@/components/LdJson';

  export default {
    props: ['currentPage', 'icsType'],
    props: {
      currentPage: {
        type: String,
      },
      icsType: {
        type: String,
      },
      isTx: {
        type: Boolean,
        default: false,
      },
    },
    components: {
      LdJson,
    },
    data() {
      return {
        siteUrl: window.SITE_URL,
        districtId: null,
        sticky: Stickyfill(),
        showStockTabs: false,
        showAgentTabs: false,
        showNewsTabs: false,
        showBranchTabs: false,
      };
    },
    mounted() {
      this.sticky.add(this.$refs.affix);
    },
    computed: {
      activeStockTab() {
        return this.currentPage === 'search' || 
          this.currentPage === 'tender' || 
          this.currentPage === 'openday' ||
          this.currentPage === 'opendayList';
      },
      activeAgentTab() {
        return this.currentPage === 'agent'
          this.currentPage === 'mitaclub' || 
          this.currentPage === 'recommend' || 
          this.currentPage === 'topsales';
      },
      activeNewstab(){
        return this.currentPage === 'dailynews' || 
          this.currentPage === 'columns' || 
          this.currentPage === 'news' ||         
          this.currentPage === 'research' || 
          this.currentPage === 'district_analysis' || 
          this.currentPage === 'shops_map' || 
          this.currentPage === 'walk_street_guide';
      },
      activeBranchTab(){
        return this.currentPage === 'branch' || 
        this.currentPage === 'contactus' || 
        this.currentPage === 'easy_i' || 
        this.currentPage === 'recruitment' || 
        this.currentPage === 'partner' || 
        this.currentPage === 'member' || 
        this.currentPage === 'payment_method';
      },
      items() {
        const currentPage = this.currentPage;
        const items = [{ href: this.siteUrl, text: this.$t('main.MAIN_PAGE') }];

        switch (currentPage) {
          case 'search':
            items.push({ href: `${this.siteUrl}`, text: this.$t('find.SEARCH_PROPERTIES') });
            break;
          case 'transaction':
            items.push({ href: `${this.siteUrl}`, text: this.$t('main.TRANSACTION_GENERAL') });
            break;
          case 'buildingIndex':
            items.push({ href: `${this.siteUrl}`, text: this.$t('building_page.BLDG_PAGE_SH') });
            break;
          case 'buildingList':
            items.push({ href: `${this.siteUrl}building`, text: this.$t('building_page.BLDG_PAGE_SH') });
            items.push({ href: `${this.siteUrl}building/list`, text: this.$t('building_page.BLDG_LIST_PAGE') });
            break;
          case 'buildingDetail':
            items.push({ href: `${this.siteUrl}building`, text: this.$t('building_page.BLDG_PAGE_SH') });
            items.push({ href: `${this.siteUrl}building/list`, text: this.$t('building_page.BLDG_LIST_PAGE') });
            items.push({ href: `${this.siteUrl}building/details/${this.buildingId}`, text: this.buildingName });
            break;
          case 'history':
            items.push({ href: `${this.siteUrl}`, text: this.$t('main.HISTORY') });
            break;
          default:
            break;
        }
        return items;
      },
      corpUrl() {
        let url = 'https://www.legendupstarholdings.com/';
        if (this.$i18n.locale === 'en') {
          url = 'https://www.legendupstarholdings.com/eng/';
        }
        return url;
      },
    },
  };
</script>

<style scoped>
#affixContainer {
  background: #fff15d;
  color: #000000;
  width: 100%;
  font-family: Microsoft JhengHei,Arial,sans-serif;
  position: sticky;
  z-index: 1000;
  top: 0;
  padding: 10px 0px;
}

#affixContainer.phone {
  top: 40px;
}

#affixContainer a {
  color: #000000;
}

.breadcrumb-container {
  margin: 10px 0 0 0;
}

span#icibreadcrumb > h1 {
  font-size: 13px;
  display: initial;
  font-weight: 300;
}

.heatmap {
  display: flex;
  position: absolute;
  z-index: 10000;
  top: -28px;
  left: 50%;
  transform: translateX(-50%);
}

#affixContainer ul#highlightLinks {
  list-style-type: none;
  padding: 0;
  overflow: hidden;
  justify-content: center;
  display: flex;
  margin: 0;
}

#affixContainer ul#highlightLinks > li {
  margin: 2px 1px;
  font-size: 14px;
  font-weight: 600;
}

#affixContainer ul#highlightLinks > li > a {
  display: block;
  color: #000;
  text-align: center;
  padding: 2px 0;
  border-top-color: transparent;
  border-left-color: transparent;  
  text-decoration: none;
  min-width: 85px;  
}

#affixContainer ul#highlightLinks > li > a:first-child {
  white-space: nowrap;
}

#affixContainer ul#highlightLinks > li > a + a {
  margin-top: 3px;
}

#affixContainer ul#highlightLinks > li > a {
  background: #f6f6f6;
}
#affixContainer ul#highlightLinks > li > a:hover,
#affixContainer ul#highlightLinks > li > a.active {
  background: #fff05e;
}
#affixContainer.i {
  background: #47337C;
}
#affixContainer.c {
  background: #008cba;
}
#affixContainer.s {
  background: #da4e00;
}
#affixContainer.i .breadcrumb-item,
#affixContainer.c .breadcrumb-item,
#affixContainer.s .breadcrumb-item {
  color: #fff;
}

#affixContainer.i ul#highlightLinks > li > a, 
#affixContainer.c ul#highlightLinks > li > a, 
#affixContainer.s ul#highlightLinks > li > a {
  color: #fff;
}

#affixContainer.i a, #affixContainer.c a, #affixContainer.s a
{
  color: #ffffff;
}

#icibreadcrumb {
  padding-top: 1px;
  display: block;
  font-size: 13px;
  font-weight: 300;
}

.breadcrumb-item {
  display: inline-block;
}
.breadcrumb-item::after {
  content: " / ";
  white-space: pre;
}
.breadcrumb-item:last-child:after {
  content: none;
}
.breadcrumb-item > a {
  font-size: 13px;
  font-weight: 300;
}
.breadcrumb-item > h1 {
  font-size: 13px;
  display: initial;
  font-weight: 300;
}

button[form='searchForm'].btn {
  background: #fef07f;
  color: #000000;
}

@media (max-width: 767px) {
  #affixContainer{
    display: block;
  }
  #affixContainer .form-group {
      margin-bottom: 5px;
      width: auto;
  }

  #affixContainer #dist_code.form-control {
    width: 105px;
    display: inline-block;
  }

  #affixContainer #searchForm-t.form-control {
    width: 117px;
    display: inline-block;
  }

  .heatmap {
    display: none;
  }
}
@media only screen and (max-width: 480px) {
  .no-pad-left-xs {
    padding-left: 0px
  }
  #affixContainer {
    padding: 0;
  }
}
@media (min-width: 768px) and (max-width: 991px) {
  #affixContainer #searchForm-t {
    width: 200px;
  }
}
@media (min-width: 992px) and (max-width: 1199px) {
  #affixContainer #searchForm-t {
    width: 300px;
  }
}
@media (min-width: 1200px) {
  #affixContainer #searchForm-t {
    width: 400px;
  }
}

@media screen and (min-width:992px) and (max-width:1199px) {
  .container-fluid {
    width: 970px;
  }
}

@media screen and (min-width:1200px) {
  .container-fluid {
    width: 1170px; 
  }
}

@media print {
  #affixContainer {
    display: none;
  }
}
</style>
